import ProductComparison, { ProductComparisonProps } from './ProductComparison'
import { ProductComparisonTableProps, ProductComparisonProductProps } from './ProductComparisonTable'

export default ProductComparison
export { ProductComparison }
export type { ProductComparisonProps, ProductComparisonProductProps, ProductComparisonTableProps }
